type FaviconPreviewProps = {
  className?: string;
  src: string | null;
};

export const FaviconPreview = (props: FaviconPreviewProps) => {
  return (
    <svg
      className={props.className}
      width="348"
      height="126"
      viewBox="0 0 348 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H336C342.627 0 348 5.37258 348 12V114C348 120.627 342.627 126 336 126H12C5.37259 126 0 120.627 0 114V12Z"
        fill="#F5F5F5"
      />
      <mask id="path-2-inside-1_2247_222719" fill="white">
        <path d="M24 43.1367C24 39.823 26.6863 37.1367 30 37.1367H314C317.314 37.1367 320 39.823 320 43.1367V83.1367C320 86.4504 317.314 89.1367 314 89.1367H30C26.6863 89.1367 24 86.4504 24 83.1367V43.1367Z" />
      </mask>
      <path
        d="M24 43.1367C24 39.823 26.6863 37.1367 30 37.1367H314C317.314 37.1367 320 39.823 320 43.1367V83.1367C320 86.4504 317.314 89.1367 314 89.1367H30C26.6863 89.1367 24 86.4504 24 83.1367V43.1367Z"
        fill="#F5F5F5"
      />
      <path
        d="M30 37.1367V39.1367H314V37.1367V35.1367H30V37.1367ZM320 43.1367H318V83.1367H320H322V43.1367H320ZM314 89.1367V87.1367H30V89.1367V91.1367H314V89.1367ZM24 83.1367H26V43.1367H24H22V83.1367H24ZM30 89.1367V87.1367C27.7909 87.1367 26 85.3459 26 83.1367H24H22C22 87.555 25.5817 91.1367 30 91.1367V89.1367ZM320 83.1367H318C318 85.3459 316.209 87.1367 314 87.1367V89.1367V91.1367C318.418 91.1367 322 87.555 322 83.1367H320ZM314 37.1367V39.1367C316.209 39.1367 318 40.9276 318 43.1367H320H322C322 38.7184 318.418 35.1367 314 35.1367V37.1367ZM30 37.1367V35.1367C25.5817 35.1367 22 38.7184 22 43.1367H24H26C26 40.9276 27.7909 39.1367 30 39.1367V37.1367Z"
        fill="#D5D7DA"
        mask="url(#path-2-inside-1_2247_222719)"
      />
      <path
        d="M179 44.1367C182.314 44.1367 185 46.823 185 50.1367V61.1367H318V83.1367C318 85.3456 316.209 87.1367 314 87.1367H30C27.791 87.1367 26.0003 85.3456 26 83.1367V61.1367H79V50.1367C79 46.823 81.6863 44.1367 85 44.1367H179Z"
        fill="#FAFAFA"
      />
      <path
        d="M309.038 77.0576C309.612 77.0576 310.077 77.5232 310.077 78.0967C310.077 78.67 309.611 79.1348 309.038 79.1348C308.465 79.1346 308 78.6699 308 78.0967C308 77.5233 308.465 77.0578 309.038 77.0576ZM309.038 73.5967C309.612 73.5967 310.077 74.0612 310.077 74.6348C310.077 75.2083 309.612 75.6729 309.038 75.6729C308.465 75.6726 308 75.2082 308 74.6348C308 74.0614 308.465 73.5969 309.038 73.5967ZM309.038 70.1348C309.611 70.1348 310.077 70.5995 310.077 71.1729C310.077 71.7464 309.612 72.2119 309.038 72.2119C308.465 72.2117 308 71.7463 308 71.1729C308 70.5996 308.465 70.135 309.038 70.1348Z"
        fill="#D0D5DD"
      />
      <image
        x="84"
        y="47.1387"
        width="12"
        height="12"
        preserveAspectRatio="xMidYMid meet"
        xlinkHref={props.src ?? undefined}
      />
      <path
        d="M99 53.1387C99 49.825 101.686 47.1387 105 47.1387H167C170.314 47.1387 173 49.825 173 53.1387C173 56.4524 170.314 59.1387 167 59.1387H105C101.686 59.1387 99 56.4524 99 53.1387Z"
        fill="#EAECF0"
      />
      <path
        d="M85 74.1367C85 69.7184 88.5817 66.1367 93 66.1367H292C296.418 66.1367 300 69.7184 300 74.1367C300 78.555 296.418 82.1367 292 82.1367H93C88.5817 82.1367 85 78.555 85 74.1367Z"
        fill="#EAECF0"
      />
      <circle cx="36" cy="49.1387" r="4" fill="#EAECF0" />
      <circle cx="47" cy="49.1387" r="4" fill="#EAECF0" />
      <circle cx="58" cy="49.1387" r="4" fill="#EAECF0" />
      <path
        d="M194.71 52.3477H197.92V53.8477H194.71V57.0567H193.21V53.8477H190V52.3477H193.21V49.1367H194.71V52.3477Z"
        fill="#98A2B3"
      />
      <path
        d="M37.5488 71.1953L34.8691 73.874H41.7686V75.374H34.8711L37.5488 78.0518L36.4883 79.1123L32.5303 75.1533L32 74.623L36.4883 70.1348L37.5488 71.1953Z"
        fill="#D0D5DD"
      />
      <path
        d="M53.9883 71.1953L56.668 73.874H49.7686V75.374H56.666L53.9883 78.0518L55.0488 79.1123L59.0068 75.1533L59.5371 74.623L55.0488 70.1348L53.9883 71.1953Z"
        fill="#D0D5DD"
      />
      <path
        d="M77.3495 74.5605H73.037V73.0605H74.8094C74.5345 72.6987 74.1858 72.3943 73.7792 72.1748C73.0803 71.7978 72.2661 71.6921 71.494 71.8789C70.7217 72.0657 70.0459 72.532 69.5975 73.1865C69.1493 73.841 68.9598 74.6383 69.0653 75.4238C69.1708 76.2094 69.5645 76.9288 70.1698 77.4424C70.775 77.9558 71.5494 78.227 72.3436 78.2041C73.138 78.1812 73.896 77.865 74.4706 77.3174C75.0449 76.7698 75.396 76.0296 75.4559 75.2393L76.204 75.2959L76.951 75.3525C76.8631 76.5131 76.3484 77.5999 75.5057 78.4033C74.6629 79.2066 73.5518 79.6704 72.3875 79.7041C71.2232 79.7377 70.087 79.3393 69.1991 78.5859C68.3111 77.8325 67.7339 76.7768 67.579 75.623C67.4241 74.4694 67.7023 73.2994 68.3602 72.3389C69.0182 71.3783 70.0093 70.6948 71.1415 70.4209C72.2736 70.1471 73.4672 70.3023 74.492 70.8555C75.0138 71.1371 75.4728 71.5122 75.8495 71.957V70.248H77.3495V74.5605Z"
        fill="#D0D5DD"
      />
      <mask id="path-16-inside-2_2247_222719" fill="white">
        <path d="M24 43.1367C24 39.823 26.6863 37.1367 30 37.1367H314C317.314 37.1367 320 39.823 320 43.1367V83.1367C320 86.4504 317.314 89.1367 314 89.1367H30C26.6863 89.1367 24 86.4504 24 83.1367V43.1367Z" />
      </mask>
      <path
        d="M30 37.1367V39.1367H314V37.1367V35.1367H30V37.1367ZM320 43.1367H318V83.1367H320H322V43.1367H320ZM314 89.1367V87.1367H30V89.1367V91.1367H314V89.1367ZM24 83.1367H26V43.1367H24H22V83.1367H24ZM30 89.1367V87.1367C27.7909 87.1367 26 85.3459 26 83.1367H24H22C22 87.555 25.5817 91.1367 30 91.1367V89.1367ZM320 83.1367H318C318 85.3459 316.209 87.1367 314 87.1367V89.1367V91.1367C318.418 91.1367 322 87.555 322 83.1367H320ZM314 37.1367V39.1367C316.209 39.1367 318 40.9276 318 43.1367H320H322C322 38.7184 318.418 35.1367 314 35.1367V37.1367ZM30 37.1367V35.1367C25.5817 35.1367 22 38.7184 22 43.1367H24H26C26 40.9276 27.7909 39.1367 30 39.1367V37.1367Z"
        fill="#D5D7DA"
        mask="url(#path-16-inside-2_2247_222719)"
      />
    </svg>
  );
};
